"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var client_1 = require("react-dom/client");
var hooks_1 = require("react-relay/hooks");
var react_router_dom_1 = require("react-router-dom");
var FullStory = __importStar(require("@fullstory/browser"));
var js_api_loader_1 = require("@googlemaps/js-api-loader");
var core_1 = require("@material-ui/core");
var styles_1 = require("@material-ui/core/styles");
var pickers_1 = require("@material-ui/pickers");
var date_fns_1 = __importDefault(require("@material-ui/pickers/adapter/date-fns"));
var recoil_1 = require("recoil");
var ErrorBoundary_1 = __importDefault(require("./components/ErrorBoundary"));
var ErrorMessage_1 = __importDefault(require("./components/ErrorMessage"));
var FullScreenLoadingPlaceholder_1 = __importDefault(require("@/components/LoadingPlaceholder/FullScreenLoadingPlaceholder"));
var Services_1 = require("./services/Services");
var theme_1 = require("./themes/theme");
var providers_1 = require("./providers");
require("react-resizable/css/styles.css");
var SegmentAnalyticsProvider_1 = require("@/analytics/segment/SegmentAnalyticsProvider");
var sentry_1 = __importDefault(require("@/analytics/sentry"));
var env_1 = __importDefault(require("@/env"));
var version_checker_1 = require("@/lib/version-checker");
var AlgoliaSearchProvider_1 = __importDefault(require("@/providers/AlgoliaSearchProvider"));
var CourierProvider_1 = __importDefault(require("@/providers/CourierProvider"));
var RelayEnvironment_1 = __importDefault(require("@/relay/RelayEnvironment"));
var MainRoutes_1 = __importDefault(require("@/routes/MainRoutes"));
var Root = function (_a) {
    var callback = _a.callback;
    return (react_1.default.createElement(styles_1.ThemeProvider, { theme: theme_1.theme },
        react_1.default.createElement("div", { ref: callback }),
        react_1.default.createElement(core_1.CssBaseline, null),
        react_1.default.createElement(ErrorBoundary_1.default, { changeTitle: true, errorComponent: ErrorMessage_1.default },
            react_1.default.createElement(react_1.Suspense, { fallback: react_1.default.createElement(FullScreenLoadingPlaceholder_1.default, { noDelay: true }) },
                react_1.default.createElement(recoil_1.RecoilRoot, null,
                    react_1.default.createElement(react_router_dom_1.BrowserRouter, null,
                        react_1.default.createElement(IsOnLatestAppVersion, null),
                        react_1.default.createElement(providers_1.NotificationProvider, null,
                            react_1.default.createElement(SegmentAnalyticsProvider_1.SegmentAnalyticsProvider, null,
                                react_1.default.createElement(pickers_1.LocalizationProvider, { dateAdapter: date_fns_1.default },
                                    react_1.default.createElement(hooks_1.RelayEnvironmentProvider, { environment: RelayEnvironment_1.default },
                                        react_1.default.createElement(providers_1.AuthProvider, null,
                                            react_1.default.createElement(CourierProvider_1.default, null,
                                                react_1.default.createElement(Services_1.ServicesContextProvider, null,
                                                    react_1.default.createElement(AlgoliaSearchProvider_1.default, null,
                                                        react_1.default.createElement(MainRoutes_1.default, null)))))))))))))));
};
var onRender = function () {
    // Initialize Errors
    (0, sentry_1.default)();
    // Load FullStory on initial render
    FullStory.init({ orgId: env_1.default.FULLSTORY_ORG_ID });
    // Load google amps api because it gets adblockled otherwise
    if (window.requestIdleCallback) {
        window.requestIdleCallback(function () {
            var loader = new js_api_loader_1.Loader({
                apiKey: env_1.default.GOOGLE_PLACES_PUBLIC_KEY,
                version: 'weekly',
                libraries: ['places'],
            });
            loader.load().then(window.initPlacesAutocomplete);
        }, {
            timeout: 7000,
        });
    }
    else {
        var loader = new js_api_loader_1.Loader({
            apiKey: env_1.default.GOOGLE_PLACES_PUBLIC_KEY,
            version: 'weekly',
            libraries: ['places'],
        });
        loader.load().then(window.initPlacesAutocomplete);
    }
};
var rootContainer = document.getElementById('root');
if (rootContainer) {
    var root = (0, client_1.createRoot)(rootContainer);
    if (root) {
        root.render(react_1.default.createElement(Root, { callback: onRender }));
    }
}
var IsOnLatestAppVersion = function () {
    var location = (0, react_router_dom_1.useLocation)();
    (0, react_1.useEffect)(function () {
        /*
        Force a full page reload if app is not on the latest version.
        This will guarantee customers are always on the most recent
        version of the app the moment they decide to navigate away from
        their current path.
      */
        if (!(0, version_checker_1.isOnLatest)()) {
            window.location.reload();
        }
    }, [location.pathname]);
    return null;
};
/**
 * Setup service worker
 * TODO
 */
if ('serviceWorker' in navigator) {
    // window.addEventListener('load', () => {
    //   navigator.serviceWorker.register('./serviceworker.js').then(
    //     (registration) => {
    //       console.log('Hurray! Service workers with scope: ');
    //     },
    //     (err) => {
    //       console.log('Oops! ServiceWorker registration failed: ', err);
    //     },
    //   );
    // });
}
/**
 * Clear console on hot reload
 */
window.addEventListener('message', function (e) {
    if (env_1.default.IS_NODE_ENV_LOCAL && e.data && e.data.type === 'webpackInvalid') {
        // eslint-disable-next-line no-console
        console.clear();
    }
});
/**
 * Why did you render?
 */
if (env_1.default.IS_NODE_ENV_LOCAL) {
    // const whyDidYouRender = require('@welldone-software/why-did-you-render');
    // whyDidYouRender(React, {
    //   trackAllPureComponents: true,
    //   // logOnDifferentValues: true,
    // });
}
//# sourceMappingURL=index.js.map